import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const sanitizeFilename = (name) => {
  const s = String(name || 'report').replace(/[/\\?%*:|"<>]/g, '-').replace(/\s+/g, ' ').trim();
  return s || 'report';
};

/**
 * Captures a DOM node (e.g. `.section91-report-print-root`) and saves a multi-page A4 PDF.
 * Uses rasterized output so on-screen Tailwind styling is preserved.
 */
export async function downloadDomAsA4Pdf(element, filenameBase = 'Section-9-1-report') {
  if (!element) {
    throw new Error('No element to export');
  }

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    allowTaint: true,
    logging: false,
    backgroundColor: '#f9fafb',
  });

  const imgData = canvas.toDataURL('image/png', 1.0);
  const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let y = 0;
  let isFirst = true;
  while (y > -imgHeight) {
    if (!isFirst) pdf.addPage();
    isFirst = false;
    pdf.addImage(imgData, 'PNG', 0, y, imgWidth, imgHeight);
    y -= pageHeight;
  }

  const safe = sanitizeFilename(filenameBase);
  pdf.save(`${safe}-Section-9.1.pdf`);
}
